export const corporateLawConst = {
  path: "/single-programs/corporate-law",
  title: "ФАКУЛЬТЕТ ПРАВА — КОРПОРАТИВНОЕ ПРАВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Корпоративное право — юридическая основа современного бизнеса</h2>
      <p>
        Корпоративное право играет ключевую роль в управлении компаниями, обеспечении законности деловых операций и защите интересов
        акционеров. Эта программа подойдет тем, кто хочет работать на стыке права и бизнеса, участвовать в сделках, инвестициях и защите
        корпоративных интересов.
      </p>
      <p>
        Студенты изучают правовые аспекты ведения бизнеса в ЕС, регистрацию компаний, договорное право, корпоративное управление, вопросы
        ответственности и международную деловую практику.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы корпоративного и коммерческого права</li>
        <li>Регистрация и ликвидация компаний</li>
        <li>Слияния и поглощения (M&A)</li>
        <li>Акционерные соглашения и права инвесторов</li>
        <li>Договорное право и сопровождение сделок</li>
        <li>Ответственность юридических лиц</li>
        <li>Корпоративное налогообложение</li>
        <li>Комплаенс, антикоррупционное и антимонопольное регулирование</li>
      </ul>
      <p>
        Программа сочетает теорию с практикой: студенты анализируют кейсы, работают с документацией, учатся сопровождать бизнес-процессы и
        соблюдать юридические стандарты ЕС.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Корпоративный юрист в международной компании</li>
        <li>Специалист по комплаенсу и внутренним рискам</li>
        <li>Юрисконсульт по сделкам и договорам</li>
        <li>Правовой аналитик в инвестиционных и венчурных фондах</li>
        <li>Консультант по корпоративному управлению и правовой безопасности</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€55,000 до €105,000 в год</strong> — особенно в крупных компаниях и юридических консалтинговых фирмах.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Возможность обучения на русском или английском языке</li>
        <li>Очная или дистанционная форма</li>
        <li>Программа, соответствующая реальным требованиям бизнеса</li>
        <li>Поддержка карьерного роста и помощь с трудоустройством в ЕС</li>
        <li>Доступ к юридическим платформам и корпоративным симуляциям</li>
      </ul>
      <p>Корпоративное право — это профессия, которая защищает интересы бизнеса и обеспечивает его устойчивость.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам с выбором программы, подготовкой документов и подачей заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Корпоративное право — юридическая основа современного бизнеса
    Корпоративное право играет ключевую роль в управлении компаниями, обеспечении законности деловых операций и защите интересов акционеров. Эта программа подойдет тем, кто хочет работать на стыке права и бизнеса, участвовать в сделках, инвестициях и защите корпоративных интересов.
    Студенты изучают правовые аспекты ведения бизнеса в ЕС, регистрацию компаний, договорное право, корпоративное управление, вопросы ответственности и международную деловую практику.
    Что вы будете изучать?
    • Основы корпоративного и коммерческого права
    • Регистрация и ликвидация компаний
    • Слияния и поглощения (M&A)
    • Акционерные соглашения и права инвесторов
    • Договорное право и сопровождение сделок
    • Ответственность юридических лиц
    • Корпоративное налогообложение
    • Комплаенс, антикоррупционное и антимонопольное регулирование
    Программа сочетает теорию с практикой: студенты анализируют кейсы, работают с документацией, учатся сопровождать бизнес-процессы и соблюдать юридические стандарты ЕС.
    Кем можно работать после окончания?
    • Корпоративный юрист в международной компании
    • Специалист по комплаенсу и внутренним рискам
    • Юрисконсульт по сделкам и договорам
    • Правовой аналитик в инвестиционных и венчурных фондах
    • Консультант по корпоративному управлению и правовой безопасности
    Зарплата в Европе: от €55,000 до €105,000 в год — особенно в крупных компаниях и юридических консалтинговых фирмах.
    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Возможность обучения на русском или английском языке
    • Очная или дистанционная форма
    • Программа, соответствующая реальным требованиям бизнеса
    • Поддержка карьерного роста и помощь с трудоустройством в ЕС
    • Доступ к юридическим платформам и корпоративным симуляциям
    Корпоративное право — это профессия, которая защищает интересы бизнеса и обеспечивает его устойчивость.
    Как поступить?
    Приёмная комиссия поможет вам с выбором программы, подготовкой документов и подачей заявки.
  `,
};
